import {
  CreateScheduleExceptionDto,
  DeleteScheduleExceptionDto,
  GetScheduleExceptionDto,
  MessageResponseDto,
  ScheduleExceptionApiFp,
  ScheduleExceptionControllerGet200Response,
  UpdateScheduleExceptionDto,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseScheduleExceptionModel =
  ScheduleExceptionControllerGet200Response;
export type GetScheduleExceptionModel = GetScheduleExceptionDto;
export type MutateResponseScheduleExceptionModel = MessageResponseDto;
export type CreateScheduleExceptionModel = CreateScheduleExceptionDto;
export type UpdateScheduleExceptionModel = UpdateScheduleExceptionDto;
export type DeleteScheduleExceptionModel = DeleteScheduleExceptionDto;

export const apiScheduleExceptionFp = ScheduleExceptionApiFp(apiConfig);
export const getScheduleExceptionController =
  apiScheduleExceptionFp.scheduleExceptionControllerGet;
export const getUpcomingExceptionsController =
  apiScheduleExceptionFp.scheduleExceptionControllerGetUpcoming;
export const getPublicUpcomingExceptionsController =
  apiScheduleExceptionFp.scheduleExceptionControllerGetPublicUpcoming;
export const getPublicNextAvailableDateController =
  apiScheduleExceptionFp.scheduleExceptionControllerGetNextAvailableDate;
export const getNextAvailableDateRestrictedController =
  apiScheduleExceptionFp.scheduleExceptionControllerGetNextAvailableDateRestricted;
export const createScheduleExceptionController =
  apiScheduleExceptionFp.scheduleExceptionControllerCreate;
export const updateScheduleExceptionController =
  apiScheduleExceptionFp.scheduleExceptionControllerEdit;
export const deleteScheduleExceptionController =
  apiScheduleExceptionFp.scheduleExceptionControllerDelete;

export const QueryKeyScheduleException = QueryKey.ScheduleException;
